// Mobile Menu Logic
// Handles opening/closing of navigation drawer on mobile devices

(function() {
  'use strict';

  // Mobile Menu Class
  function MobileMenu() {
    this.init();
  }

  MobileMenu.prototype = {
    init: function() {
      console.log('MobileMenu initialized');
      this.bindEvents();
      this.initAccessibility();
    },

    bindEvents: function() {
      var self = this;

      // Open mobile menu
      $(document).on('click', '.js-drawer-open-nav', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(self.isOpen()) {
          self.close();
        } else {
          self.open();
        }
      });

      // Close mobile menu
      $(document).on('click', '.js-drawer-close', function(e) {
        e.preventDefault();
        self.close();
      });

      // Close on overlay click
      $(document).on('click', '#NavDrawerOverlay', function(e) {
        self.close();
      });

      // Close on escape key
      $(document).on('keydown', function(e) {
        if (e.keyCode === 27) { // Escape key
          self.close();
        }
      });

      // Handle first-level submenu toggles
      $(document).on('click', '.mobile-nav__toggle .collapsible-trigger', function(e) {
        console.log('First-level submenu toggle clicked');
        e.preventDefault();
        e.stopImmediatePropagation(); // Prevent other collapsible handlers
        var $button = $(this);
        var $parent = $button.closest('.mobile-nav__item');
        var $sublist = $parent.find('.mobile-nav__sublist').first();

        console.log('Parent:', $parent.length, 'Sublist:', $sublist.length);

        if ($parent.hasClass('is-open')) {
          self.closeSubmenu($parent, $sublist);
        } else {
          self.openSubmenu($parent, $sublist);
        }
      });

      // Handle second-level submenu toggles
      $(document).on('click', '.mobile-nav__child-item .collapsible-trigger', function(e) {
        console.log('Second-level submenu toggle clicked');
        e.preventDefault();
        e.stopImmediatePropagation(); // Prevent other collapsible handlers
        var $button = $(this);
        var $parent = $button.closest('.mobile-nav__child-item');
        var moduleId = $button.attr('aria-controls');
        var $sublist = $('#' + moduleId);

        if ($button.hasClass('is-open')) {
          self.closeSubmenu($parent, $sublist);
        } else {
          // Close other open second-level submenus at the same level
          $parent.siblings('.mobile-nav__child-item').find('.collapsible-trigger.is-open').each(function() {
            var $siblingButton = $(this);
            var $siblingParent = $siblingButton.closest('.mobile-nav__child-item');
            var siblingModuleId = $siblingButton.attr('aria-controls');
            var $siblingSublist = $('#' + siblingModuleId);
            if ($siblingButton.hasClass('is-open')) {
              $siblingButton.removeClass('is-open');
              $siblingSublist.css('height', '0');
              $siblingButton.attr('aria-expanded', 'false');
            }
          });

          // Open current submenu
          $button.addClass('is-open');
          $sublist.css('height', 'auto');

          // Update ARIA
          $button.attr('aria-expanded', 'true');

          // Trigger event
          $(document).trigger('mobile-menu:submenu-opened', [$parent, $sublist]);
        }
      });
    },

    initAccessibility: function() {
      // Add ARIA attributes for accessibility
      $('.js-drawer-open-nav').attr({
        'aria-expanded': 'false',
        'aria-controls': 'NavDrawer',
        'aria-label': 'Open navigation menu'
      });

      $('.js-drawer-close').attr({
        'aria-label': 'Close navigation menu'
      });
    },

    open: function() {
      var $drawer = $('#NavDrawer');
      var $overlay = $('#NavDrawerOverlay');
      var $button = $('.js-drawer-open-nav');

      if ($drawer.length === 0) {
        console.error('NavDrawer not found');
        return;
      }

      // Prevent body scroll
      $('html, body').addClass('js-drawer-open');

      // Show drawer and overlay
      $drawer.addClass('drawer--is-open');
      $overlay.addClass('drawer__overlay--visible');

      // Update ARIA attributes
      $button.attr('aria-expanded', 'true');

      // Focus management
      $drawer.find('.drawer__close-button').focus();

      // Trigger event
      $(document).trigger('mobile-menu:opened');
    },

    close: function() {
      var $drawer = $('#NavDrawer');
      var $overlay = $('#NavDrawerOverlay');
      var $button = $('.js-drawer-open-nav');

      if ($drawer.length === 0) {
        return;
      }

      // Allow body scroll
      $('html, body').removeClass('js-drawer-open');

      // Hide drawer and overlay
      $drawer.removeClass('drawer--is-open');
      $overlay.removeClass('drawer__overlay--visible');

      // Update ARIA attributes
      $button.attr('aria-expanded', 'false');

      // Return focus to trigger button
      $button.focus();

      // Close all open submenus
      this.closeAllSubmenus();

      // Trigger event
      $(document).trigger('mobile-menu:closed');
    },

    openSubmenu: function($parent, $sublist) {
      // Close other open submenus at the same level
      $parent.siblings('.mobile-nav__has-sublist').each(function() {
        var $sibling = $(this);
        var $siblingSublist = $sibling.find('.mobile-nav__sublist').first();
        if ($sibling.hasClass('is-open')) {
          $sibling.removeClass('is-open');
          $siblingSublist.css('height', '0');
          $sibling.find('.mobile-nav__toggle button').attr('aria-expanded', 'false');
        }
      });

      // Open current submenu
      $parent.addClass('is-open');
      $sublist.css('height', 'auto');

      // Update ARIA
      $parent.find('.mobile-nav__toggle button').attr('aria-expanded', 'true');

      // Trigger event
      $(document).trigger('mobile-menu:submenu-opened', [$parent, $sublist]);
    },

    closeSubmenu: function($parent, $sublist) {
      $parent.removeClass('is-open');
      $sublist.css('height', '0');

      // Update ARIA
      $parent.find('.mobile-nav__toggle button').attr('aria-expanded', 'false');

      // Trigger event
      $(document).trigger('mobile-menu:submenu-closed', [$parent, $sublist]);
    },

    closeAllSubmenus: function() {
      // Close first-level submenus
      $('.mobile-nav__has-sublist.is-open').each(function() {
        var $parent = $(this);
        var $sublist = $parent.find('.mobile-nav__sublist').first();
        $parent.removeClass('is-open');
        $sublist.css('height', '0');
        $parent.find('.mobile-nav__toggle button').attr('aria-expanded', 'false');
      });

      // Close second-level submenus
      $('.mobile-nav__child-item .collapsible-trigger.is-open').each(function() {
        var $button = $(this);
        var $parent = $button.closest('.mobile-nav__child-item');
        var moduleId = $button.attr('aria-controls');
        var $sublist = $('#' + moduleId);
        $button.removeClass('is-open');
        $sublist.css('height', '0');
        $button.attr('aria-expanded', 'false');
      });
    },

    isOpen: function() {
      return $('#NavDrawer').hasClass('drawer--is-open');
    }
  };

  // Initialize when DOM is ready
  $(document).ready(function() {
    // Only initialize on mobile/tablet
    if ($(window).width() < 1024) {
      window.themeMobileMenu = new MobileMenu();
    }

    // Re-initialize on window resize
    $(window).on('resize', function() {
      if ($(window).width() < 1024 && !window.themeMobileMenu) {
        window.themeMobileMenu = new MobileMenu();
      } else if ($(window).width() >= 1024 && window.themeMobileMenu) {
        // Close menu if open on desktop
        if (window.themeMobileMenu.isOpen()) {
          window.themeMobileMenu.close();
        }
        window.themeMobileMenu = null;
      }
    });
  });

  // Expose to global scope
  window.theme = window.theme || {};
  window.theme.MobileMenu = MobileMenu;

})();
